import { Component } from "@angular/core";
import { XOField } from './xo-field.component';

@Component({
  selector: "xo-field-timestamp",
  templateUrl: "./xo-field-timestamp.component.html"
})
export class XOFieldTimestamp extends XOField {
}
